import React, { Component, useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container, Form } from 'react-bootstrap'
import {
    Link, Outlet,
    useLocation,
    useNavigate,
    useParams,
    useMatch,
    useResolvedPath,
    matchPath
} from "react-router-dom";

import { localTimeButtonClicked, changeCompetition, changeRsc, changeLocale } from 'state-management/actions'
import { connect } from 'react-redux';
import Clock from 'components/general/Clock';
import PhaseContainer from 'components/common/selectors/selector-phase/PhaseContainer';
import { getURL } from 'helpers/utils';
import { useGetCompetitions, useGetConfigSports, useGetDisciplines, useGetEventUnits, useGetLanguages, useGetRoutes } from 'helpers/commonCodes';
import { getSportsCodes, getPhases, getConfigCompetitions } from "data/Querys";
import { useQueries, useQuery } from 'react-query'
import { getLongEventRSC } from "helpers/rsc"
import Label from "components/general/Label"
import { getCompetitions, getDisciplines, getEventUnits, getPositions, getConfigSports, getNocs, getPlacingsByDiscipline } from 'data/Querys';
import Loader from 'components/general/Loader';
import NotAvailable from 'components/common/NotAvailable';
import { useUrlFriendlyToParameters, useGetURL, useGetPath } from 'helpers/urlFriendly';
import FooterCompetition from './FooterCompetition';
import HeaderCompetition from './HeaderCompetition';
import { useSelector, useDispatch } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import { getLevelRSC, getUnit, getEventRSC } from 'helpers/rsc';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';
import { LocaleToStore } from 'helpers/utils';
import { useTranslation } from "react-i18next";
import { ALL_URL } from 'helpers/utils';
import FilterBar from 'components/common/FilterBar';
import Ticker from 'components/common//Ticker';

//HOC (Higth Order Component) component Link in order to style selected 
function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });

    return (
        <div className="nav-schedule" >
            <Link
                to={to}
                {...props}
            >
                {children}
            </Link>
            {/* {match && " (active)"}*/}
        </div>
    );
}



const NavSecondary = ({ paramsURL }) => {

    let obj = useGetPath()
    let objUrl = obj(paramsURL.mirs_language);

    paramsURL.mirs_discipline = paramsURL.mirs_discipline || ALL_URL.ALL_DISC;
    paramsURL.mirs_event = paramsURL.mirs_event || ALL_URL.ALL_EVENT;


    //Change object if make changes over params make changes in componets related   (Change URL object)
    paramsURL.mirs_rsc = getLongEventRSC(paramsURL.mirs_rsc)
    let urlCompetitionSchedule = useGetURL(paramsURL, 'competitionschedule')
    let urlSchedule = useGetURL(paramsURL, 'schedule')
    let urlMultiMedallists = useGetURL(paramsURL, 'multimedallists')
    let urlRanking = useGetURL(paramsURL, 'ranking')
    let urlTodayMatches = useGetURL(paramsURL, 'todayMatches')
    let urlTodayAthMatches = useGetURL(paramsURL, 'todayAthMatches')
    let urlTodayTeamMatches = useGetURL(paramsURL, 'todayTeamMatches')
    let urlCompetitionStatus = useGetURL(paramsURL, 'competitionstatus')
    let urlHearingSchedule = useGetURL(paramsURL, 'hearingschedule')
    let urlMedallists = useGetURL(paramsURL, 'medallists')
    let urlMedal = useGetURL(paramsURL, 'medal')
    let urlAthletes = useGetURL(paramsURL, 'athletes')
    let urlTeams = useGetURL(paramsURL, 'teams')
    let urlCoaches = useGetURL(paramsURL, 'coaches')
    let urlTechnicalOfficials = useGetURL(paramsURL, 'technicalofficials')
    let urlHorses = useGetURL(paramsURL, 'horses')
    let urlNocList = useGetURL(paramsURL, 'noclist')
    let urlEntries = useGetURL(paramsURL, 'entries')
    let urlReports = useGetURL(paramsURL, 'reports')
    let urlScheduleByNoc = useGetURL(paramsURL, 'schedulebynoc')
    let urlEntriesByNoc = useGetURL(paramsURL, 'entriesbynoc')
    let urlMedallistsByNoc = useGetURL(paramsURL, 'medallistsbynoc')
    let urlProfileByNoc = useGetURL(paramsURL, 'profilebynoc')
    let urlRecords = useGetURL(paramsURL, 'records')

    let showOneTodaysMatches = '|NONE|'.includes(paramsURL.mirs_discipline)
    let showBothTodaysMatches = '|NONE|'.includes(paramsURL.mirs_discipline)
    let showCompetitionStatus = '|SAL|'.includes(paramsURL.mirs_discipline)
    let noShowRanking = !('|ATH|CRD|GAR|GLF|MTB|OWS|PDL|SAL|SWA|TEN|TRI|WLF|'.includes(paramsURL.mirs_discipline)) // No shows ranking for KRA or PAR
    let showRecordsEG2023 = (paramsURL.mirs_competition === 'EG2023' && '|ARC|ATH|CLB|CSP|CTR|MPN|ROW|SHO|SWM|WLF|'.includes(paramsURL.mirs_discipline))
    let canShowCompetition = (paramsURL.mirs_competition !== 'EG2023')
    let CompetitionEG2023 = (paramsURL.mirs_competition === 'EG2023')

    return (
        <>
            <Navbar.Toggle aria-controls="navbar-results" />
            <Navbar.Collapse id="navbar-results" className='justify-content-end'>
                {(objUrl.url.isSchedule || objUrl.url.isCompetitionSchedule || objUrl.url.isCompetitionStatus || objUrl.url.isHearingSchedule)
                    &&
                    <>
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlCompetitionSchedule}><Label data={'Schedule'} /></Nav.Link>
                        </Nav>}
                        {!paramsURL.mirs_discipline && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlSchedule}><Label data={'MenuSchedules'} /></Nav.Link>
                        </Nav>}

                        {showCompetitionStatus && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlCompetitionStatus}><Label data={'LabelCompetitionStatus'} /></Nav.Link>
                        </Nav>
                        }
                        {showCompetitionStatus && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlHearingSchedule}><Label data={'LabelHearingSchedule'} /></Nav.Link>
                        </Nav>
                        }
                    </>
                }

                {(objUrl.url.isSchedule || objUrl.url.isResult || objUrl.url.isRanking || objUrl.url.isBracket || objUrl.url.isPool ) && paramsURL.mirs_discipline &&
                    <>
                        {false && CompetitionEG2023 && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlSchedule}><Label data={'MenuSchedules'} /></Nav.Link>
                        </Nav>}
                        <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlReports}><Label data={'Reports'} /></Nav.Link>
                        </Nav>
                    </>
                }

                {(objUrl.url.isSchedule || objUrl.url.isResult || objUrl.url.isRanking || objUrl.url.isBracket || objUrl.url.isPool) && paramsURL.mirs_discipline &&
                    <>
                        {showRecordsEG2023 && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlRecords}><Label data={'LabelRecords'} /></Nav.Link>
                        </Nav>}
                    </>
                }



                {(objUrl.url.isResult || objUrl.url.isPool || objUrl.url.isBracket || objUrl.url.isRanking)
                    && <>

                        <PlacingNav />
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlSchedule}><Label data={'LabelSchedule'} /></Nav.Link>
                        </Nav>}
                        {noShowRanking && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlRanking}><Label data={'LabelRanking'} /></Nav.Link>
                        </Nav>}

                        {CompetitionEG2023 && <NavPoolesBrackets />}


                        {showOneTodaysMatches &&
                            <Nav className=" mb-2 mb-lg-0">
                                <Nav.Link as={CustomLink} to={urlTodayMatches}><Label data={'LabelTodayMatches'} /></Nav.Link>
                            </Nav>}
                        {showBothTodaysMatches && <>
                            <Nav className=" mb-2 mb-lg-0">
                                <Nav.Link as={CustomLink} to={urlTodayAthMatches}><Label data={'LabelTodayMatches'} /></Nav.Link>
                            </Nav>
                            <Nav className="ms-auto mb-2 mb-lg-0">
                                <Nav.Link as={CustomLink} to={urlTodayTeamMatches}><Label data={'LabelTodayTeamMatches'} /></Nav.Link>
                            </Nav></>
                        }
                    </>

                }


                {(objUrl.url.isMedal || objUrl.url.isMedallists || objUrl.url.isMultiMedallists)
                    && <>
                        <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlMedal}><Label data={'LabelMedal'} /></Nav.Link>
                        </Nav>
                        <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlMedallists}><Label data={'LabelMedallists'} /></Nav.Link>
                        </Nav>
                        {false && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlMultiMedallists}><Label data={'MultiMedallists'} /></Nav.Link>
                        </Nav>}
                    </>
                }
                {(objUrl.url.isAthletes || objUrl.url.isTeams || objUrl.url.isCoaches || objUrl.url.isTechnicalOfficials || objUrl.url.isHorses || objUrl.url.isNocList || objUrl.url.isEntries)
                    && <>
                        <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlAthletes}><Label data={'LabelAthletes'} /></Nav.Link>
                        </Nav>
                        <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlTeams}><Label data={'Teams'} /></Nav.Link>
                        </Nav>
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlCoaches}><Label data={'Coaches'} /></Nav.Link>
                        </Nav>}
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlTechnicalOfficials}><Label data={'TechnicalOfficials'} /></Nav.Link>
                        </Nav>}
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlHorses}><Label data={'Horses'} /></Nav.Link>
                        </Nav>
                        }
                        <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlNocList}><Label data={'LabelNocs'} /></Nav.Link>
                        </Nav>
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlEntries}><Label data={'LabelEntries'} /></Nav.Link>
                        </Nav>}
                    </>
                }


                {(objUrl.url.isScheduleByNoc || objUrl.url.isEntriesByNoc || objUrl.url.isMedallistsByNoc || objUrl.url.isProfileByNoc)
                    && <>
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlScheduleByNoc}><Label data={'NOCSchedule'} /></Nav.Link>
                        </Nav>}
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlEntriesByNoc}><Label data={'NOCEntries'} /></Nav.Link>
                        </Nav>}
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlMedallistsByNoc}><Label data={'NocMedallists'} /></Nav.Link>
                        </Nav>}
                        {canShowCompetition && <Nav className="mb-2 mb-lg-0">
                            <Nav.Link as={CustomLink} to={urlProfileByNoc}><Label data={'NOCProfile'} /></Nav.Link>
                        </Nav>}
                    </>
                }





            </Navbar.Collapse>
        </>
    )
};






const MainContainer = () => {
    //const { results, configs, values } = useLoadCC();
    const { results, configs, values } = useLoadCC();
    const location = useLocation();
    const params = useUrlFriendlyToParameters();
    const { mirs_competition, mirs_language, mirs_discipline, mirs_event_rsc, mirs_rsc, mirs_date, mirs_event, mirs_noc } = useUrlFriendlyToParameters()
    const isLoading = results?.some(result => result.isLoading)
    const isLoadingConfig = configs?.some(config => config.isLoading)
    const isError = results?.some(result => result?.isError)
    const labelSwimOff = Label({ data: "SwimOff" })




    const dataEventUnits = useGetEventUnits({
        mirs_competition: values.mcompetition,
        mirs_discipline: values.mdiscipline,
        mirs_language: values.mlanguage
    })

    const dataDisciplines = useGetDisciplines({
        mirs_competition: values.mcompetition,
        mirs_language: values.mlanguage
    })




    dataEventUnits?.eventUnits?.forEach((dt) => {
        let unit = getLevelRSC(dt.code) === "UNIT" ? "-" + getUnit(dt?.code) : ""
        dt.mirs_Description = dt?.description?.replace(/ /g, "_") + unit;
        dt.mirs_ShortDescription = dt?.shortDescription?.replace(/ /g, "_") + unit;
        if (getLevelRSC(dt.code) === "PHASE") {
            let phaseFilter = dataEventUnits?.eventUnits?.find(item => item.code === dt.code.substring(0, dt.code.length - 10) + "RR--------")
            if (!phaseFilter) {
                let h = { ...dt }
                h.order = Number(h.order) - 0.5
                h.shortDescription = dt.shortDescription + " " + labelSwimOff
                h.longDescription = dt.longDescription + " " + labelSwimOff
                h.description = dt.description + " " + labelSwimOff
                h.code = dt.code.substring(0, dt.code.length - 10) + "RR--------";
                h.mirs_Description = h?.description?.replace(/ /g, "_");
                h.mirs_ShortDescription = h?.shortDescription?.replace(/ /g, "_");
                if (mirs_discipline === 'SWM') { dataEventUnits?.eventUnits.push(h) }
            }
        }
    });

    let event = dataEventUnits?.eventUnits?.find(item => item.mirs_Description === mirs_event_rsc && item.code.charAt(4) !== '-')?.code //No get codes like BKBM-
    event = event || mirs_event_rsc

    let eventFilter = dataEventUnits?.eventUnits?.find(item => item.mirs_Description === mirs_event)?.code
    eventFilter = eventFilter || mirs_event

    //duplicates phase and unit get units 
    let startWith = getEventRSC(event)
    let unit = dataEventUnits?.eventUnits?.find(item => item.mirs_ShortDescription === mirs_rsc && item.code.startsWith(startWith) && item.code !== getLongEventRSC(event))?.code
    unit = unit ? unit : event

    const paramsToParameters = {
        mirs_language: values.mlanguage,
        mirs_competition: values.mcompetition,
        mirs_discipline: values.mdiscipline,
        mirs_event_rsc: event,
        mirs_rsc: unit,
        mirs_date: mirs_date,
        mirs_event: eventFilter,
        mirs_noc: mirs_noc,
    }



    //States
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    //Parameters from URL (can be friendly)
    //let params = props.router.params;
    const { i18n } = useTranslation();
    //const location = props.router.location//useLocation();
    const globalProps = useSelector(getGlobalProps)
    const dispatch = useDispatch();
    //Parameters codes 
    // const paramsToParameters = props.router.paramsToParameter;
    const dataLanguage = useGetLanguages()

    useEffect(() => {
        //Store in Redux competition
        dispatch(changeCompetition(paramsToParameters.mirs_competition));
        dispatch(changeRsc(paramsToParameters.mirs_rsc));
        let language = dataLanguage?.languages?.find(item => item.lang === paramsToParameters.mirs_language?.toUpperCase())?.description
        language = language?.toLowerCase() || 'en'
        dispatch(changeLocale(language));
        i18n.changeLanguage(paramsToParameters.mirs_language?.toLowerCase())
    }, [location]);

    let obj = useGetPath()
    let objUrl = obj(paramsToParameters.mirs_language);

    let componentResult;
    if ((objUrl.url.isResult || objUrl.url.isPool || objUrl.url.isBracket || objUrl.url.isRanking)) {//&& process.env.REACT_APP_DEVELOPMENT === 'true'

        if (paramsToParameters.mirs_competition === 'EG2023') {
            componentResult = <> <FilterBar /></>
        } else {
            componentResult = <PhaseContainer expanded={isNavCollapsed} />
        }
    }
    //Compatibilizar las url siempre 
    params.mirs_rsc = params.mirs_rsc || params.mirs_event_rsc
    //Copy object in order to change 
    let paramsURL = { ...paramsToParameters };




    let sw = true

    //No error if config not exits
    if (isError) { return <NotAvailable />; }

    if (!values.mcompetition && !values.mlanguage) {
        //  return <><NotAvailable /><div>No competition &&  language</div></>
        sw = false

    }

    if (isLoading || isLoadingConfig || (!values.mcompetition || !values.mlanguage)) {
        //return <Loader className='mirs-overlayCC' text={values?.mdiscipline} />
        //return <Loader />
        sw = false
    }

    if ((values.mdiscipline && !dataEventUnits?.eventUnits)) {
        // return <><NotAvailable /><Label data="HeaderEventUnits" /></>
        sw = false


    }
    if (values.mcompetition && !dataDisciplines?.disciplines) {
        // return <><NotAvailable /><Label data="LabelDisciplines" /></>
        sw = false

    }

    return (
        <div id='mirs-app-container'>
            <section id="mirs-head-app"></section>
            <HeaderCompetition />
            <Navbar variant={"dark"} expand="lg" id="mirs-second-navigation-bar" >
                <Container>
                    <Navbar.Brand className="d-flex">
                        <Form.Select
                            className="me-2"
                            //value={paramsURL.mirs_event}
                            onChange={() => dispatch(localTimeButtonClicked(!globalProps.localtime))}>
                            <option key='1' value=''>
                                <Label data={'LabelLocalTime'} />
                            </option>
                            <option key='2' value=''>
                                <Label data={'LabelVenueTime'} />
                            </option>
                        </Form.Select>
                        <Clock />
                    </Navbar.Brand>
                    <NavSecondary paramsURL={paramsURL} />
                </Container>
            </Navbar>
            <div className='mirs-third-navigation-bar'>
                {sw && <Ticker />}
                {sw && componentResult}
            </div>

            {/* An <Outlet> renders whatever child route is currently active,
     so you can think about this <Outlet> as a placeholder for
     the child routes we defined above. */}
            <section id="mirs-body-app">
                <Container className="viewsHeight">
                    {sw && <Outlet />}
                </Container>
            </section>
            <section id="mirs-footer-app">
                <FooterCompetition />
            </section>
        </div>
    );
}

export default MainContainer;

export function useLoadCC() {

    const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    //LocaleToStore('fr')    console.log("TEST")
    const dataLanguage = useGetLanguages()
    let language = dataLanguage?.languages?.find(item => item.description === mirs_language?.toUpperCase())
    language = language?.lang || mirs_language


    let mlanguage = language?.toUpperCase();
    //mlanguage = mlanguage || mirs_language


    const { isError: isErrorCompetitions, isLoading: isLoadingCompetitions, data: dataCompetitions } = useQuery(
        {
            queryKey: ['CC_Competitions', mlanguage?.toUpperCase()],
            queryFn: getCompetitions,
            refetchInterval: 0,
            //staleTime: Infinity,
            refetchIntervalInBackground: true,
            //notifyOnChangeProps: ['data', 'error'],
            enabled: !!mlanguage
        });



    let mcompetition
    if (dataCompetitions?.competitions) {
        dataCompetitions?.competitions?.forEach((dt) => {
            dt.mirs_Description = dt?.description?.replace(/ /g, "_");
        });
        mcompetition = dataCompetitions?.competitions?.find(item => item.mirs_Description === mirs_competition)?.code
    }
    mcompetition = mcompetition || mirs_competition

    const { isError: isErrorDisciplines, isLoading: isLoadingDisciplines, data: dataDisciplines } = useQuery(
        {
            queryKey: ['CC_Disciplines', mcompetition, mlanguage?.toUpperCase()],
            queryFn: getDisciplines,
            refetchInterval: 0,
            //staleTime: Infinity,
            refetchIntervalInBackground: true,
            //notifyOnChangeProps: ['data', 'error'],
            enabled: !!mcompetition
        });


    let mdiscipline = null;
    if (dataDisciplines)
        dataDisciplines?.disciplines?.forEach((dt) => {
            dt.mirs_Description = dt?.description?.replace(/ /g, "_");
            mdiscipline = dataDisciplines?.disciplines?.find(item => item.mirs_Description === mirs_discipline)?.code
        });

    mdiscipline = mdiscipline || mirs_discipline?.length > 3 ? null : mirs_discipline
    //Read disciplines from memory 
    //Convert urlfriendly in codes
    let queryArray = [];
    queryArray.push({
        queryKey: ['CC_EventUnits', mcompetition, mdiscipline, mlanguage?.toUpperCase()],
        queryFn: getEventUnits,
        refetchInterval: 0,
        refetchIntervalInBackground: true,
        enabled: !!mdiscipline
    })



    //Load data from SportCodes CC file
    queryArray.push({
        queryKey: ['CC_Positions', mcompetition, mdiscipline, mlanguage?.toUpperCase()],
        queryFn: getPositions,
        refetchInterval: 0,
        refetchIntervalInBackground: true,
        enabled: !!mcompetition && !!mdiscipline
    })




    //Load data from SportCodes CC file
    queryArray.push({
        queryKey: ['SportCodes', mcompetition, mlanguage?.toUpperCase()],
        queryFn: getSportsCodes,
        refetchInterval: 0,
        //staleTime: Infinity,
        refetchIntervalInBackground: true,
        retry: false,
        suspense: false,
        enabled: !!mcompetition
    })

    queryArray.push({
        queryKey: ['CC_Nocs', mcompetition, mlanguage?.toUpperCase()],
        queryFn: getNocs,
        refetchInterval: 0,
        //staleTime: Infinity,
        refetchIntervalInBackground: true,
        retry: false,
        suspense: false,
        enabled: !!mcompetition
    })

    let configArray = [];
    //Load data from Config Discipline  File
    configArray.push({
        queryKey: ['ConfigCompetitions', mcompetition],
        queryFn: getConfigCompetitions,
        refetchInterval: 0,
        //staleTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
        enabled: !!mcompetition
    })

    //Load data from Config Discipline  File
    configArray.push({
        queryKey: ['ConfigSports', mcompetition, mdiscipline],
        queryFn: getConfigSports,
        refetchInterval: 0,
        //staleTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
        enabled: !!mcompetition && !!mdiscipline
    })



    const results = useQueries(queryArray);
    const configs = useQueries(configArray);


    let values = { mcompetition: mcompetition, mdiscipline: mdiscipline, mlanguage: mlanguage }

    return ({ results: results, configs: configs, values: values })

}

function PlacingNav() {
    const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()

    let paramsURL = {}
    paramsURL.mirs_competition = mirs_competition;
    paramsURL.mirs_language = mirs_language;
    paramsURL.mirs_discipline = mirs_discipline;

    let urlPlacing = useGetURL(paramsURL, 'placings')

    //Get Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['placingTable', mirs_competition, mirs_discipline, mirs_language],
            queryFn: getPlacingsByDiscipline,
            refetchInterval: 60000,
            staleTime: 50000,
            refetchIntervalInBackground: true,
            enabled: mirs_discipline === 'ATH'
        });
    if (data?.placingsBySport) {
        return (<Nav className="ms-auto mb-2 mb-lg-0">
            <Nav.Link as={CustomLink} to={urlPlacing}><Label data={'Placings'} /></Nav.Link>
        </Nav>)
    }
    else {
        return null
    }


}

function NavPoolesBrackets() {
    let paramsURL = useUrlFriendlyToParameters();
    const { mirs_rsc, mirs_language, mirs_competition, mirs_discipline } = paramsURL;
    const _event = getEventRSC(mirs_rsc);
    const dataConfigSport = useGetConfigSports(paramsURL);
    const isH2H = dataConfigSport?.isH2H
    paramsURL.mirs_rsc = getLongEventRSC(mirs_rsc)
    const urlPooles = useGetURL(paramsURL, 'pool')
    const urlBrackets = useGetURL(paramsURL, 'bracket')

    //Load data Phases
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['phasesData', mirs_competition, mirs_language, _event],
            queryFn: getPhases,
            refetchInterval: 0,
        });

    let hasPooles = false
    let hasBrackets = false
    if (isH2H) {
        hasBrackets = true;
        paramsURL.mirs_rsc = getLongEventRSC(mirs_rsc);
        const dataFilter = data ? data.filter(item => item.order === '8') : [];
        hasPooles = dataFilter.length > 0;
    }
    return (
        <>
            {hasBrackets && <Nav className="mb-2 mb-lg-0">
                <Nav.Link as={CustomLink} to={urlBrackets}><Label data={'LabelBrackets'} /></Nav.Link>
            </Nav>}
            {hasPooles && <Nav className="mb-2 mb-lg-0">
                <Nav.Link as={CustomLink} to={urlPooles}><Label data={'HeaderPools'} /></Nav.Link>
            </Nav>}
        </>
    )

}


